// Box Id Status
export const SKIPPED = 'SKIPPED';
export const EXPIRED = 'EXPIRED';
export const NOT_SUBSCRIBED = 'NOT_SUBSCRIBED';
export const DELIVERED = 'DELIVERED';
export const UNAVAILABLE = 'UNAVAILABLE';
